import Vue from 'vue';
import VueFeather from 'vue-feather';

Vue.component('FeatherIcon', VueFeather);
